'use strict';

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

exports["default"] = function (theme) {
  return {
    autocompleteItem: {
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
      padding: theme.autocomplete.item.paddingLarge,
      height: 56,
      lineHeight: theme.autocomplete.item.lineHeight,
      background: theme.autocomplete.item.background,
      transition: theme.transition(['background']),
      position: 'relative',
      '&.disabled': {
        opacity: theme.disabledOpacity,
        cursor: 'default'
      },
      '&.hidden': {
        display: 'none'
      },
      '&:hover': (0, _assign2["default"])(theme.autocomplete.item.hover, {}),
      '&.active': (0, _assign2["default"])(theme.autocomplete.item.hover, {}),
      '&.unActive': {
        '&:hover': {
          background: theme.autocomplete.item.background
        }
      },
      '& .nameContainer': {
        display: 'flex',
        flexGrow: 1,
        flexShrink: 1,
        flexBasis: 'auto',
        overflow: 'hidden',
        alignItems: 'center'
      },
      '& .label': {
        marginLeft: 12,
        color: theme.autocomplete.item.labelColor,
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden'
      },
      '&.medium': {
        height: 40,
        padding: theme.autocomplete.item.paddingMedium
      }
    }
  };
};